<template>
  <div class="none"></div>
</template>

<script>
export default {
  data() {
    return {
      androidUrl:process.env.VUE_APP_ANDROID_URL,
    };
  },
  created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      location.replace(
        "https://apps.apple.com/cn/app/%E8%81%9A%E5%B8%88%E5%82%85/id1506700998"
      );
    }
    if (isAndroid) {
      location.replace(this.androidUrl);
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.none {
  width: 100%;
  height: 100vw;
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 5;
}
</style>
